module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-2000.052f7fa9.svg";